import { gql } from '@apollo/client'

export default gql(`
mutation createProductionStudio($name: String!, $project: String) {
    createProductionStudio(
        input: {
            name: $name
        },
        project: $project
    ) {
        id
        name
        assetCount
        source
    }
}`
)
